import React, { useState } from "react";
import { inject, observer } from "mobx-react";
import { Box, Typography } from "@mui/material";
import { ContentCopy } from "@mui/icons-material";
import { useFormik } from "formik";
import * as yup from "yup";

import { Button, ButtonWrapper, FormFieldsBuilder } from "components/ui";
import { RootStore } from "store/root.store";
import CongratulationScreen from "components/modals/AddIntegrationModal/components/CongratulationScreen";
import { copyToClipboard } from "tools";

const validationSchema = yup.object({
  name: yup.string().required("Name is required"),
});

const AddStreamingIntegrationModal = ({ store }: { store?: RootStore }) => {
  const [step, setStep] = useState(1);
  const [generatedKey, setGeneratedKey] = useState("");

  const formik = useFormik({
    initialValues: {
      name: "",
    },
    validationSchema,
    onSubmit: async (values) => {
      try {
        const result = await store?.streamingIntegrations.createIntegration(values.name);

        if (result) {
          copyToClipboard({ value: result.key });
          setGeneratedKey(result.key);
        }

        setStep(2);
      } catch (error) {
        // Error is already handled by the API method
      }
    },
  });

  if (step === 2) {
    return (
      <CongratulationScreen
        component={
          <Box textAlign="center">
            <Typography variant="main" fontSize={16}>
              Please save your streaming key:
            </Typography>
            <Box
              sx={{
                cursor: "pointer",
              }}
              marginTop={2}
              onClick={() => copyToClipboard({ value: generatedKey })}
            >
              <Typography
                sx={{ wordBreak: "break-word" }}
                display="flex"
                justifyContent="center"
                gap={1}
                variant="table"
                fontSize={16}
              >
                {generatedKey}
                <ContentCopy />
              </Typography>
            </Box>
          </Box>
        }
      />
    );
  }

  const items = [
    {
      property: "name",
      label: "Integration Name",
    },
  ];

  return (
    <Box
      onSubmit={formik.handleSubmit}
      component="form"
      gap={5}
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
    >
      <FormFieldsBuilder formik={formik} items={items} />

      <ButtonWrapper marginTop={0}>
        <>
          <Button onClick={store?.ui.closeModal} text="Cancel" variant="text" />
          <Button type="submit" text="Create" />
        </>
      </ButtonWrapper>
    </Box>
  );
};

export default inject("store")(observer(AddStreamingIntegrationModal));
